// Modules
import React from "react";

const MicrowaveIcon = (props) => {
	return (
		<svg
			height="1em"
			viewBox="0 0 512 512"
			width="1em"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<path d="M468,88H44a28.032,28.032,0,0,0-28,28V380a28.032,28.032,0,0,0,28,28h4v24a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8V408H400v24a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8V408h4a28.032,28.032,0,0,0,28-28V116A28.032,28.032,0,0,0,468,88ZM96,424H64V408H96Zm352,0H416V408h32Zm32-44a12.013,12.013,0,0,1-12,12H44a12.013,12.013,0,0,1-12-12V116a12.013,12.013,0,0,1,12-12H468a12.013,12.013,0,0,1,12,12Z" />
				<path d="M344,120H56a8,8,0,0,0-8,8V368a8,8,0,0,0,8,8H344a8,8,0,0,0,8-8V128A8,8,0,0,0,344,120Zm-8,240H64V136H336Z" />
				<path d="M456,134H376a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V142A8,8,0,0,0,456,134Zm-8,48H384V150h64Z" />
				<circle cx="384" cy="286" r="8" />
				<circle cx="384" cy="254" r="8" />
				<circle cx="384" cy="222" r="8" />
				<circle cx="416" cy="286" r="8" />
				<circle cx="416" cy="254" r="8" />
				<circle cx="416" cy="222" r="8" />
				<circle cx="448" cy="286" r="8" />
				<circle cx="448" cy="254" r="8" />
				<circle cx="448" cy="222" r="8" />
				<path d="M416,310a33,33,0,1,0,33,33A33.038,33.038,0,0,0,416,310Zm0,50a17,17,0,0,1-8-31.992V335a8,8,0,0,0,16,0v-6.992A17,17,0,0,1,416,360Z" />
				<path d="M199,296a8,8,0,0,0,16,0c0-12.522-4.684-19.212-8.446-24.588C203.329,266.806,201,263.478,201,256s2.329-10.806,5.554-15.412C210.316,235.212,215,228.522,215,216a8,8,0,0,0-16,0c0,7.478-2.329,10.806-5.554,15.412C189.684,236.788,185,243.478,185,256s4.684,19.212,8.446,24.588C196.671,285.194,199,288.522,199,296Z" />
				<path d="M247,296a8,8,0,0,0,16,0c0-12.522-4.684-19.212-8.446-24.588C251.329,266.806,249,263.478,249,256s2.329-10.806,5.554-15.412C258.316,235.212,263,228.522,263,216a8,8,0,0,0-16,0c0,7.478-2.329,10.806-5.554,15.412C237.684,236.788,233,243.478,233,256s4.684,19.212,8.446,24.588C244.671,285.194,247,288.522,247,296Z" />
				<path d="M151,296a8,8,0,0,0,16,0c0-12.522-4.684-19.212-8.446-24.588C155.329,266.806,153,263.478,153,256s2.329-10.806,5.554-15.412C162.316,235.212,167,228.522,167,216a8,8,0,0,0-16,0c0,7.478-2.329,10.806-5.554,15.412C141.684,236.788,137,243.478,137,256s4.684,19.212,8.446,24.588C148.671,285.194,151,288.522,151,296Z" />
			</g>
		</svg>
	);
};

export default MicrowaveIcon;
